import { render } from "./PlayedTracklist.vue?vue&type=template&id=45bfa7dc"
import script from "./PlayedTracklist.vue?vue&type=script&lang=js"
export * from "./PlayedTracklist.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-mtn-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__